import React from 'react';

import { getClickType } from '../../../sharedModules/getClickType';
import { getWidgetInitialiser } from '../../../sharedModules/getWidgetInitialiser';
import { loadCSS } from '../../../utils/loadCSS';
import { WidgetResult } from '../../hooks/useAnalytics';
import getButtonText from '../../modules/getButtonText';
import { InitialiserProps } from '../../types/InitialiserProps';
import type { WidgetProps } from '../../types/WidgetProps';
import { Consumer } from '../GenericComponents/HawkWidget/HawkWidgetProviderContext';

import styles from './styles/inbody.css';

loadCSS('inbody');

const InBody: React.FC<WidgetProps> = (props) => {
  const {
    articleUrl,
    genericSharedComponents: { HawkWidgetStandard, AffiliateLink },
    result,
  } = props;

  if (result === WidgetResult.MISSING) {
    return null;
  }

  return (
    <HawkWidgetStandard {...props}>
      <Consumer>
        {(value): JSX.Element => {
          const { dealData, translate } = value;

          return (
            <ul className={styles.container}>
              {dealData.dealType === 'subscriptions' && (
                <span className={styles.heading}>
                  {translate('inbodyHeading', [dealData.deals[0].model])}
                </span>
              )}
              {dealData.deals.map((deal) => (
                <li key={deal?.id}>
                  <AffiliateLink
                    deal={deal}
                    className="inline"
                    clickType={getClickType({
                      link: deal.offer.link,
                      articleUrl,
                      productType: deal.product_type,
                    })}
                  >
                    <span>{getButtonText(deal, true, translate)}</span>
                  </AffiliateLink>
                </li>
              ))}
            </ul>
          );
        }}
      </Consumer>
    </HawkWidgetStandard>
  );
};

InBody.getInitialiserProps = ({
  renderProps,
  attributes,
  getWidgetResponse,
  getModelOffersResponse,
  getSeasonalResponse,
  getAiredaleFeeds,
  getModelSuggestions,
  postForWidgetResponse,
  editorial,
  defaultParams,
  origin,
  dataLinkMerchant,
}): InitialiserProps => {
  // Get the initialiser for the widget & render it when the initialiser resolves
  return getWidgetInitialiser({
    editorial,
    defaultParams,
    origin,
    dataLinkMerchant,
    getWidgetResponse,
    getModelOffersResponse,
    getSeasonalResponse,
    getAiredaleFeeds,
    getModelSuggestions,
    postForWidgetResponse,
    attributes,
    ...renderProps,
  });
};

export default InBody;
